import React, {Suspense} from 'react';
import {useSelector} from 'react-redux';
import Stack from '@mui/material/Stack';
import {BrowserRouter as Router} from 'react-router-dom';
import {useFlag} from 'react-unleash-flags';
import Loader from './components/Loader';
import Container from './components/Container';
import Header from './components/Header';
import Maintenance from './components/Maintenance';
import AuthFeature from './features/auth/auth-feature';
import HeaderNavFeature from './features/navigation/header-nav-feature';
import AuthenticatedRoutesFeature from './features/routes/authenticated-routes-feature';
import UnauthenticatedRoutesFeature from './features/routes/unauthenticated-routes-feature';

import * as consts from './utils/constants';

function App() {
  const {fetching, loggedIn} = useSelector(state => state.auth);
  const maintenanceModeFlag = useFlag(consts.FEATURE_FLAG_MAINTENANCE_MODE);

  if (maintenanceModeFlag && maintenanceModeFlag.enabled === true) {
    return (
      <Router>
        <Header />
        <Container>
          <Maintenance />
        </Container>
      </Router>
    );
  }

  return (
    <Router>
      <AuthFeature />
      <Stack
        bgcolor={loggedIn ? 'grey.100' : 'transparent'}
        minHeight="100vh"
        position="relative">
        {/** Home decides where to land: properties when they exist, welcome when not */}
        <Header logoTo={consts.SLUG_HOME} disableDivider={loggedIn}>
          <HeaderNavFeature />
        </Header>
        {fetching === false && (
          <Suspense fallback={<Loader />}>
            {loggedIn ? (
              <AuthenticatedRoutesFeature />
            ) : (
              <UnauthenticatedRoutesFeature />
            )}
          </Suspense>
        )}
      </Stack>
    </Router>
  );
}

export default App;
